import { Injectable } from '@angular/core';
import {
  LoginAuthWithCredentials,
  LoginOAuth,
  OauthAEMConfig,
  SwapAuthForAccessTokens
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class UtilMethodsHelperSupportService {
  isRememberMeApiFlowEnableFalse(
    authConfig: OauthAEMConfig,
    rememberMeWithPromptLogin: boolean
  ): boolean {
    return !authConfig.REMEMBERME_API_FLOW_ENABLE || rememberMeWithPromptLogin;
  }

  checkForResourceNotFoundError(apiResponse: LoginAuthWithCredentials) {
    let errorAvailable = false;
    if (this.isResourceNotFound(apiResponse)) {
      errorAvailable = true;
    }
    return errorAvailable;
  }

  isResourceNotFound(apiResponse: LoginAuthWithCredentials): boolean {
    return (
      apiResponse?.error?.code === 'RESOURCE_NOT_FOUND' ||
      apiResponse?.code === 'RESOURCE_NOT_FOUND'
    );
  }

  generateStrRandomForCodeChallenge(length: number): string {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  isValidationError(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse.error &&
      authResponse.error.code &&
      authResponse.error.code === 'VALIDATION_ERROR'
    );
  }

  getPingInvalidRequestHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    return authResponse.error && authResponse.error.details
      ? authResponse.error.details[0].code ?? 'invalid_request'
      : 'invalid_request';
  }

  sendTokenServiceWorker(
    config: OauthAEMConfig,
    tokenResponse: SwapAuthForAccessTokens
  ) {
    if (
      config?.ENABLE_NEW_PERSISTENT_LOGIN &&
      navigator.serviceWorker &&
      navigator.serviceWorker.controller
    ) {
      this.sendMessage({
        type: 'ADD_TOKEN',
        token: tokenResponse?.access_token,
        issueTime: new Date().getTime(),
        expiresIn: tokenResponse?.expires_in
      });
      this.sendMessage({ type: 'DELETE_STATUS' });
    }
  }

  sendMessage(message: {
    type: string;
    token?: string;
    issueTime?: number;
    expiresIn?: number;
    eamStatus?: string;
    remSec?: number;
  }) {
    return new Promise(function (resolve, reject) {
      const messageChannel = new MessageChannel();
      messageChannel.port1.onmessage = function (event) {
        if (event.data.error) {
          reject(event.data.error);
        } else {
          resolve(event.data);
        }
      };

      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(message, [
          messageChannel.port2
        ]);
      }
    });
  }
}
